import PropTypes from "prop-types";
import styles from "./CompanyRejected.module.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../../../../service/config";
import { useState } from "react";
import companyStore from "../../../CompanyStore";
import { useAllProduct } from "../../../../api-context/commonApiContext";

const CompanyRejected = ({ isVisible, onclose, className = "" }) => {
  const { authTokens, isTokenValid, getNewTokens } = useAllProduct();
  const compID = companyStore.companyID;
  const navigate = useNavigate();

  const [reason, setReason] = useState("");

  const onReject = async () => {
    if (!reason.trim()) {
      alert("Reason for rejection is required!");
      return;
    }

    if (!authTokens || Object.keys(authTokens).length === 0) {
      console.log("No auth tokens available, skipping rejection.");
      return;
    }

    const obj = {
      kyb_id: companyStore.KYBId,
      status: "rejected",
      reason: reason,
    };

    try {
      // Validate token before API call
      if (!isTokenValid(authTokens.idToken)) {
        console.log("Token invalid or expired, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (!updatedAuthTokens?.idToken || !isTokenValid(updatedAuthTokens.idToken)) {
          console.error("Failed to refresh token or new token is invalid.");
          return;
        }
        authTokens.idToken = updatedAuthTokens.idToken; // Update local reference
      }

      // Update KYB status to rejected
      await axios.post(`${config.node_api_endpoint}/v1/company/kyb/update_status`, obj, {
        headers: {
          aws_cognito_id_token: authTokens.idToken,
          "Content-Type": "application/json",
        },
      });

      console.log("Request has been rejected");
      navigate(`/content/company/reject`);
    } catch (err) {
      console.error("Error rejecting KYB request:", err);
      if (err.response?.data?.error === "Token has expired. Please log in again.") {
        console.log("Token expired during request, refreshing...");
        await getNewTokens();
        const updatedAuthTokens = JSON.parse(localStorage.getItem("authTokens"));
        if (updatedAuthTokens?.idToken && isTokenValid(updatedAuthTokens.idToken)) {
          return onReject(); // Retry with new token
        }
      }
      // Optionally: Add user feedback (e.g., toast notification)
    } finally {
      onclose(); // Ensure onclose is called in all cases
    }
  };

  if (!isVisible) return null;

  return (
    <div className={`modal show d-block ${styles.rejectionModal}`} tabIndex="-1" role="dialog">
      <div className={`modal-dialog modal-dialog-centered ${styles.modalDialog}`} role="document">
        <div className={`modal-content ${styles.modalContent}`}>
          <div className={`modal-header ${styles.modalHeader}`}>
            <h5 className={`modal-title ${styles.modalTitle}`}>Please provide Reason for Rejection</h5>
            <button
              type="button"
              className={`btn-close ${styles.closeButton}`}
              aria-label="Close"
              onClick={onclose}
            ></button>
          </div>
          <div className={`modal-body ${styles.modalBody}`}>
            <textarea
              className={`form-control ${styles.textarea}`}
              placeholder="Write reason for reject..."
              value={reason}
              onChange={(e) => setReason(e.target.value)}
            />
          </div>
          <div className={`modal-footer ${styles.modalFooter}`}>
            <div
              className={`${styles.cancelButton}  d-flex justify-content-center align-items-center`}
              onClick={onclose}
            >
              <button type="button" className={`btn`} style={{ color: "#2348AB" }}>
                Cancel
              </button>
            </div>
            <div
              className={`${styles.rejectButton}  d-flex justify-content-center align-items-center`}
              onClick={onReject}
            >
              <button type="button" className={`btn`} style={{ color: "#ffffff" }}>
                Reject
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CompanyRejected.propTypes = {
  isVisible: PropTypes.bool,
  onclose: PropTypes.func,
  className: PropTypes.string,
};

export default CompanyRejected;
